import { useEffect, useMemo, useState } from "react";
import { UseSortPropType, UseSortOutputType, SortOrderType } from "../types";

export const getSortValue = (a: any, b: any, order: SortOrderType = 'none') => {
    if (order === 'ascending') {
        return a > b ? 1 : -1
    } else if (order === 'descending') {
        return a > b ? -1 : 1;
    } else return 0;
}

const useTableSort = (props: UseSortPropType): UseSortOutputType => {
    const { data = [], customSortingFunction, manual = false, sortBy: initailSortBy, sortOrder: initialSortOrder, onSortFunction } = props;

    const [sortBy, setsortBy] = useState(initailSortBy ?? '');
    const [sortOrder, setsortOrder] = useState<SortOrderType>(initialSortOrder ?? 'none');

    useEffect(() => setsortBy(initailSortBy as string), [initailSortBy])
    useEffect(() => setsortOrder(initialSortOrder as SortOrderType), [initialSortOrder])

    if (!data || data.length === 0 || manual) {
        return {
            data,
            sortBy,
            sortOrder,
            onSortFunction
        }
    }

    let cdata: any[] = [...data];

    const isDateValid = (dateStr: string) => {
        const date = new Date(dateStr) as any;
        return !isNaN(date);
    }

    const SortFunctionInternal = (a: { [x: string]: string; }, b: { [x: string]: string; }) => {

        const x = Number(a[sortBy]) ? a[sortBy] : a[sortBy].toLowerCase();
        const y = Number(b[sortBy]) ? b[sortBy] : b[sortBy].toLowerCase();

        if (isDateValid(x) && isDateValid(y)) {
            const dateX = new Date(x).getTime();
            const dateY = new Date(y).getTime();
            return getSortValue(dateX, dateY, sortOrder);
        } else {
            return getSortValue(x, y, sortOrder);
        }
    }

    if (sortBy && ['ascending', 'descending', 'none'].includes(sortOrder)) {
        if (customSortingFunction && typeof customSortingFunction === 'function') {
            cdata = cdata.sort((...params) => customSortingFunction(...params, sortBy, sortOrder));
        } else {
            cdata = cdata.sort(SortFunctionInternal)
        }
    }

    const onSortFunctionHandler = (sortBy: string, order: SortOrderType) => {
        if (!manual) {
            setsortBy(sortBy);
            setsortOrder(order);
        }
        onSortFunction && onSortFunction(sortBy, order);
    }

    return useMemo(() => ({
        data: cdata,
        sortOrder,
        sortBy,
        onSortFunction: onSortFunctionHandler
    }), [sortBy, sortOrder]);
}

export default useTableSort;